export enum AbsenceEntity {
  student = 'student',
  class = 'class',
}
